import React from 'react';
import styled from 'styled-components';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { IComment } from 'planoplan-ui-kit/core/icons/i-comment';
import { IEye } from 'planoplan-ui-kit/core/icons/i-eye';
import { textSize } from '@styles';

export const ArticleCount = ({ date = '', views = '0' }) => (
  <List>
    <Item>{date}</Item>

    <Item>
      <IEye width="16px" height="16px" fill={Colors.nobel} />
      {views}
    </Item>
  </List>
);

const List = styled.ul`
  ${Mixins.resetList()};
  ${textSize('description')};
  font-weight: 400;
  display: flex;
  color: ${Colors.dark_500};
`;

const Item = styled.li`
  display: flex;
  align-items: center;
  margin-right: 20px;

  &:last-child {
    margin-right: 0;
  }

  svg {
    margin-right: 6px;
    display: block;
  }
`;
